// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"15ecd41f","609":"14c3d963","625":"7601bc64","649":"64115b1a","652":"e73c347f","674":"494df881","863":"d1be5f78","872":"9f15e41f","900":"d8a3d064"}[chunkId] + ".chunk.js";
};